
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { store } from '../../../../../index';
import { reduxActions, RootState } from '../../../../../store'
import { IFile } from '../../../../../shared/interfaces';
import { DefaultButton, IButtonStyles } from '@fluentui/react';
import AppUtilities from '../../../../../shared/Utilities/appUtilities';
import filesService from '../../../../../services/files.service';
import { toastRef } from '../../../../Layout/Layout';


export interface FromFileProps {
    target: string
    onFileChanged?: () => void;
}
type Props = FromFileProps


const FromFile: React.FunctionComponent<Props> = props => {

    const selectCurrentProtocol = (state: RootState) => state.protocolWizardReducer.protocol;
    const currentProtocol = useSelector(selectCurrentProtocol);

    const uploadInputRef = useRef<HTMLInputElement>(null);
    const uploadButtonStyles: Partial<IButtonStyles> = {
        root: {
            marginTop: 15
        }

    }
    const onInputFileChange = (files) => {

        let filesList = props.target === 'documento' ? [files[0]] : [...files]

        filesList.forEach(file => {
            let extensionLowerCase = AppUtilities.getExtensionFromFilename(file.name);


            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                if (reader.result) {
                    const docFile: IFile = {
                        fileName: file.name,
                        extension: extensionLowerCase,
                        fileType: "Documento",
                        docBase64String: reader.result.toString().split(';base64,').pop(),
                        dimension: file.size / 1000,
                        dimensionUnit: "KB",
                        enabled: true

                    }


                    switch (props.target) {
                        case 'documento':
                            let extensionsIsAllowed = AppUtilities.extensionsAllowedForProtocolDocument.findIndex(el => el.toLowerCase() === extensionLowerCase) >= 0;
                            if (extensionLowerCase !== ".pdf" && extensionsIsAllowed) {
                                store.dispatch(reduxActions.protocolWizardActions.setProtocol({ documentFile: { ...docFile, loading: true } }));

                                filesService.convertToPdf(docFile)
                                    .then(result => {
                                        let fileName = docFile.fileName;
                                        let extension = extensionLowerCase;
                                        if (extensionLowerCase === ".p7m") {
                                            fileName = AppUtilities.extractOriginalFileNameFromP7M(fileName)
                                            extension = AppUtilities.getExtensionFromFilename(fileName);

                                            /// In caso di p7m aggiungo tra gli allegati il p7m originale e come documento principale il pdf ottenuto convertendo il contenuto del p7m
                                            if (currentProtocol?.attachments && currentProtocol?.attachments?.findIndex(el => el.fileName === docFile.fileName) < 0) {
                                                store.dispatch(reduxActions.protocolWizardActions.addAttachment(docFile));
                                                toastRef.current?.show({
                                                    severity: 'info',
                                                    summary: "Informazione",
                                                    detail: "Il file .p7m \u00e8 stato aggiunto tra gli allegati",
                                                    life: 5000
                                                });

                                            }

                                        }

                                        store.dispatch(reduxActions.protocolWizardActions.setProtocol({ documentFile: { ...docFile, fileName, extension, docBase64String: result, loading: false } }));
                                        store.dispatch(reduxActions.protocolWizardActions.setProtocolWizardTouched());

                                        if (props.onFileChanged) {
                                            props.onFileChanged();
                                        }
                                    })
                                    .catch(error => {
                                        store.dispatch(reduxActions.protocolWizardActions.setProtocol({ documentFile: undefined }));

                                        if (!error.isErrorShown) {
                                            toastRef.current?.show({
                                                severity: 'error',
                                                summary: "Attenzione",
                                                detail: "Non \u00e8 stato possibile convertire il documento",
                                                life: 5000
                                            });
                                        }
                                    });
                            }
                            else if (extensionLowerCase === '.pdf') {
                                store.dispatch(reduxActions.protocolWizardActions.setProtocol({ documentFile: docFile }));
                                store.dispatch(reduxActions.protocolWizardActions.setProtocolWizardTouched());
                                if (props.onFileChanged) {
                                    props.onFileChanged();
                                }
                            }
                            else {
                                toastRef.current?.show({ severity: 'warn', summary: 'Attenzione', detail: `Estensione del documento principale non consentita`, life: 5000 });

                            }
                            break;
                        case 'allegati':
                            if (currentProtocol?.attachments && currentProtocol?.attachments?.findIndex(el => el.fileName === docFile.fileName) < 0)
                                store.dispatch(reduxActions.protocolWizardActions.addAttachment(docFile));
                            store.dispatch(reduxActions.protocolWizardActions.setProtocolWizardTouched());
                            if (props.onFileChanged) {
                                props.onFileChanged();
                            }

                            break;

                    }

                }
            };
            reader.onerror = function (error) {
            };
        });


        if (uploadInputRef && uploadInputRef.current) {
            uploadInputRef.current.value = '';
        }

    }
    const onUploadButtonClick = () => {
        if (uploadInputRef && uploadInputRef.current) {
            uploadInputRef.current.click();
        }
    };

    return (
        <React.Fragment>
            <input
                ref={uploadInputRef}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => onInputFileChange(e.target.files)}
                multiple={props.target === 'allegati'}
                accept={props.target === 'documento' ? AppUtilities.extensionsAllowedForProtocolDocument.join(',') : undefined}
            />

            <DefaultButton
                text="Upload file"
                onClick={onUploadButtonClick}
                allowDisabledFocus
                styles={uploadButtonStyles}
            />
        </ React.Fragment>
    )
};


export default FromFile;


